import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demo-buttons',
  templateUrl: './demo-buttons.component.html',
  styleUrls: ['./demo-buttons.component.less']
})
export class DemoButtonsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
